export default "__VITE_ASSET__B4p9HuMz__"